import { post } from "../utils/backend";
import { ProductListParams, ProductListResponse, ForceOfflineParams } from "../models/Product";
import "./mock/ProductMock";
import "./mock/EnterpriseAuditMock";
import { getMockData, mock } from "./mock/Mock";

// 获取商品列表
const getProductList = async (params: ProductListParams): Promise<ProductListResponse> => {
    if (mock) {
        return getMockData("PRODUCT_LIST");
    }
    const resultOrErrorCode = await post<ProductListParams, ProductListResponse>("/product/list", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return {} as ProductListResponse;
    }
    return resultOrErrorCode;
};

// 强制下架商品
const forceOfflineProduct = async (params: ForceOfflineParams): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<ForceOfflineParams, boolean>("/product/force-offline", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const ProductApi = {
    getProductList,
    forceOfflineProduct
};